<template>
  <div class="nav">
    <img src="@/images/logo.png" alt="ibon">
    
    <span>上海亿邦工贸有限公司</span>
    <span>SHANGHAI I.BON INDUSTRIAL CO.LTD</span>
  </div>
</template>

<script>
export default {
  name: 'BanNer',
};
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
.nav {
  top: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  background-color: #318CFE;
  box-sizing: border-box;
}
img {
  vertical-align: middle;
  margin: 1em;
  border-radius: 5px;
  width: 80px;
  height: 80px;
}
span {
  font-size: 30px;
  font-weight: 400;
  color: #fff;
  margin-left: 30px;
}
</style>